import { Injectable, NgZone, inject } from "@angular/core";
import { AuthStore } from "../pages/auth/store/auth.store";

@Injectable({
  providedIn: "root",
})
export class InactivityService {
  private timeoutId: any;
  private readonly timeoutMs = 60 * 60 * 1000; // 1 hour
  private events = ["mousemove", "keydown", "mousedown", "touchstart"];

  private readonly authStore = inject(AuthStore);
  constructor(private ngZone: NgZone) {}

  isWatching: boolean = false;
  readonly LAST_ACTIVITY_KEY = "GoDigitalHR:auth:last_activity";

  storageListener = (event: StorageEvent) => {
    if (event.key === this.LAST_ACTIVITY_KEY && event.newValue) {
      const timestamp = Number(event.newValue);
      this.scheduleTimeout(timestamp);
    }
  };

  updateLastActivity = () => {
    const now = Date.now();
    localStorage.setItem(this.LAST_ACTIVITY_KEY, now.toString());
    this.scheduleTimeout(now);
  };

  public startWatching(): void {
    if (this.isWatching) return;
    this.isWatching = true;

    this.ngZone.runOutsideAngular(() => {
      window.addEventListener("storage", this.storageListener); // listen for activity change
      this.events.forEach((event) => {
        window.addEventListener(event, this.updateLastActivity, true);
      });
    });
  }

  private scheduleTimeout(lastActivity: number): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    const remaining = this.timeoutMs - (Date.now() - lastActivity);

    if (remaining <= 0) {
      this.handleInactivity();
    } else {
      this.timeoutId = setTimeout(() => {
        this.handleInactivity();
      }, remaining);
    }
  }

  private handleInactivity(): void {
    // Call logout to clear backend session and local state
    this.ngZone.run(() => {
      this.authStore.logout({data: "Session inactive for too long"});
      localStorage.clear();
      sessionStorage.clear();
    });
  }

  public stopWatching(): void {
    if (!this.isWatching) return;
    this.isWatching = false;

    window.removeEventListener("storage", this.storageListener);
    this.events.forEach((event) => {
      window.removeEventListener(event, this.updateLastActivity, true);
    });

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }
}
